<template>
  <div>
    <v-card-title class="base--text"><strong>{{ $t("Catalog.List.Categories") }}</strong></v-card-title>
        <v-card-text class="catalog-list">
          <ul>
            <li v-for="category in categories" :key="category.id">
              <v-layout  align-center :class="{ mobile: isMobile }">
                <v-flex style="white-space: normal !important; word-wrap: break-word;" class=" pb-2 pt-2" @click="selectCategory(category)">
                  <span>{{ category.name }}</span>
                </v-flex>
                <v-flex shrink v-if="!isMobile" class="pb-2 pt-2">
                  <button @click="selectCategory(category)"
                    style="width:6em" class="action white--text text-xs-center pa-1 mr-3 primary">
                    <small>EXPANDER</small>

                  </button>
                </v-flex>
                <v-flex v-else shrink class="pb-2 pt-2">

                  <button @click="selectCategory(category)" class="pa-1">
                    <v-icon color="primary">arrow_forward</v-icon>
                  </button>
                </v-flex>
              </v-layout>
            </li>
          </ul>
        </v-card-text>
  </div>
</template>
<script>
export default {
    name: "CategorieMobile",
    props: {
        categories: {
            type: Array,
            required: true
        },
        isMobile: {
          type: Boolean,
          required: true 
        }
    },
    methods: {
      selectCategory(category){
        this.$emit("Update", category)
      }
    },
    onResize() {
      if (window.innerWidth < 760)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
}
</script>
